import React from 'react';
import { Row, Col, Checkbox } from 'antd';

const NotificationControllerForm = ({notification_settings, setNotificationSettings}) => {
    return (
        <div style={{ padding: "16px 6px 0 14px" }}>
            <h2 className="share-modal-heading">Email Notification Settings</h2>
            <Row style={{ marginBottom: "30px" }} className="modal-radio-text">
                <Col span={24}>
                    <Checkbox
                    defaultChecked={true}
                    className="black-checkbox"
                    checked={notification_settings.product}
                    onChange={(e) => setNotificationSettings(e, 'product')}>
                    <span>Product Review</span>
                    </Checkbox>
                </Col>
                <Col span={24}>
                    <Checkbox
                    defaultChecked={true}
                    className="black-checkbox"
                    checked={notification_settings.space}
                    onChange={(e) => setNotificationSettings(e, 'space')}>
                    <span>Space Review</span>
                    </Checkbox>
                </Col>
                <Col span={24}>
                    <Checkbox
                    defaultChecked={true}
                    className="black-checkbox"
                    checked={notification_settings.material}
                    onChange={(e) => setNotificationSettings(e, 'material')}>
                    <span>Material Ready</span>
                    </Checkbox>
                </Col>
                <Col span={24}>
                    <Checkbox
                    defaultChecked={true}
                    className="black-checkbox"
                    checked={notification_settings.scene}
                    onChange={(e) => setNotificationSettings(e, 'scene')}>
                    <span>Render Completed</span>
                    </Checkbox>
                </Col>
            </Row>
        </div>
    );
};

export default NotificationControllerForm;